import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Box } from '@mui/material'
import FormValidation from './FormValidation'
import { useStyles } from './style'
import { STATUS } from './constants'

function FormFields(props) {
  const [forms, setForms] = useState(props.forms)
  const classes = useStyles()

  useEffect(() => {
    setForms(props.forms)
  }, [props.forms])

  const handleClick = (index, status) => {
    const modifiedForms = _.cloneDeep(forms)
    modifiedForms[index].status = status
    const filtered = modifiedForms.filter(obj => obj.status === '')
    const isRejected = modifiedForms.find(obj => obj.status === STATUS.REJECTED)
    setForms(modifiedForms)
    props.handleAction(filtered.length === forms.length ? -1 : filtered.length)
    props.setButtonDisable(isRejected ? true : filtered.length !== 0)
  }

  return (
    <Box className={classes.formWrapper}>
      {forms.map((obj, index) => {
        return (
          <FormValidation obj={obj} index={index} handleAction={handleClick} applicationStatus={props.applicationStatus} />
        )
      })}
    </Box>
  )
}


export default FormFields